import React from 'react';
import img from "../nwdn.jpg";

export const Aboutme = () => {
    return (
        <div id="aboutme" className="con">
        <div className="container py-5">
            <div className="row">
                <div className="col-lg-6 col-xm-12">
                    <div className="photo-wrap mb-5">
                        <img src={img} alt="Pic of UV" className="profile" />
                    </div>
                </div>
                <div className="col-lg-6 col-xm-12">
                    <h1 className="he1">about me</h1>
                    <p className="info">
                        <strong>Hello! I am Yuvaraj</strong>. <br /> I am currently pursuing my engineering in the branch of Computer Science & Engineering
                        in Alvas Institute Of Engineering & Technology.
                        <br />I have been started developing websites from past 1 year. <br/>I'm an Full-Stack Developer.Technologies I use are
                        HTML5, CSS3, SASS, BootStrap, ReactJs, MySQL and PhP. <br />
                        I am quite good at Programming languages such as C, C++, Python, Java, known for working with databases and back-end tools, greatfull to work
                        on editing softwares(Adobe Photoshop).<br />
                        I am ready to build Android Mobile Application.Technologies I use are android-studio software(Kotlin & Java) for developing
                        applications.
                    </p>
                </div>
            </div>
        </div>
        </div>
    )
}

export default Aboutme